// Define each variant input and corresponding description elements individually
const diamond = document.querySelector('input[value="Diamond"]');
const gold = document.querySelector('input[value="18k Gold"]');
const goldDescription = document.getElementById('goldDescription');
const goldDetails = document.querySelectorAll('#goldDetails');
const goldVermeil = document.querySelector('input[value="Gold Vermeil"]');
const goldVermeilDescription = document.getElementById('goldVermeilDescription');
const goldVermeilDetails = document.querySelectorAll('#goldVermeilDetails');
const whitechalcedony = document.querySelector('input[value="White Chalcedony"]');
const whitechalcedonyDescription = document.getElementById('whiteOpalDescription');
const whitechalcedonyDetails = document.querySelectorAll('#whitechalcedonyDetails');
const blueChalcedony = document.querySelector('input[value="Blue Chalcedony"]');
const blueChalcedonyDescription = document.getElementById('blueChalcedonyDescription');
const blueChalcedonyDetails = document.querySelectorAll('#blueChalcedonyDetails');
const orangeCarnelian = document.querySelector('input[value="Orange Carnelian"]');
const orangeCarnelianDescription = document.getElementById('orangeCarnelianDescription');
const orangeCarnelianDetails = document.querySelectorAll('#orangeCarnelianDetails');
const roseQuartz = document.querySelector('input[value="Rose Quartz"]');
const roseQuartzDescription = document.getElementById('roseQuartzDescription');
const roseQuartzDetails = document.querySelectorAll('#roseQuartzDetails');
const greenAventurine = document.querySelector('input[value="Green Aventurine"]');
const greenAventurineDescription = document.getElementById('greenAventurineDescription');
const greenAventurineDetails = document.querySelectorAll('#greenAventurineDetails');
const redCarnelian = document.querySelector('input[value="Red Carnelian"]');
const redCarnelianDescription = document.getElementById('redCarnelianDescription');
const redCarnelianDetails = document.querySelectorAll('#redCarnelianDetails');
const whiteGold = document.querySelector('input[value="White Gold"]');
const whiteGoldDescription = document.getElementById('whiteGoldDescription');
const whiteGoldDetails = document.querySelectorAll('#whiteGoldDetails');


const madeToOrder = document.querySelector("#madeToOrder");
const preOrderButtonValue = document.getElementById("preOrderButtonText");
const soldOut = document.getElementById('soldOut');

const variantDots = document.querySelectorAll("#variantDots");
const screenWidthProductPage = window.matchMedia( "(max-width: 750px)" );

// Define variant and description mappings
const variantMap = {
    "Diamond": diamond,
    "18k Gold": gold,
    "Gold Vermeil": goldVermeil,
    "White Chalcedony": whitechalcedony,
    "Blue Chalcedony": blueChalcedony,
    "Orange Carnelian": orangeCarnelian,
    "Rose Quartz": roseQuartz,
    "Green Aventurine": greenAventurine,
    "Red Carnelian": redCarnelian,
    "White Gold": whiteGold
};

const descriptionsMap = {
    "Diamond": document.getElementById('diamondDescription'),
    "18k Gold": goldDescription,
    "Gold Vermeil": goldVermeilDescription,
    "White Chalcedony": whitechalcedonyDescription,
    "Blue Chalcedony": blueChalcedonyDescription,
    "Orange Carnelian": orangeCarnelianDescription,
    "Rose Quartz": roseQuartzDescription,
    "Green Aventurine": greenAventurineDescription,
    "Red Carnelian": redCarnelianDescription,
    "White Gold": whiteGoldDescription
};

// Hide all descriptions initially
function hideAllDescriptions() {
    Object.values(descriptionsMap).forEach(description => {
        if (description) {
            description.style.display = 'none';
            description.style.opacity = '0';
        }
    });
}

// Show a specific description based on the selected variant
function showDescription(variantKey) {
    hideAllDescriptions();
    const descriptionElement = descriptionsMap[variantKey];
    if (descriptionElement) {
        descriptionElement.style.display = 'block';
        descriptionElement.style.opacity = '1';
    }
}

// Display initial variant description on page load
window.onload = function() {
    hideAllDescriptions();
    
    // Find the initially selected variant and show its description
    const initialVariant = Object.keys(variantMap).find(key => variantMap[key] && variantMap[key].checked);
    if (initialVariant) {
        showDescription(initialVariant);
    }
};

// Event listeners for variant changes
Object.keys(variantMap).forEach(variantKey => {
    if (variantMap[variantKey]) {
        variantMap[variantKey].addEventListener('change', function() {
            if (variantMap[variantKey].checked) {
                showDescription(variantKey);
            }
        });
    }
});

// Maintain hover functionality for variant dots
variantDots.forEach(variantDot => {
    const variantText = variantDot.querySelector("#variantText");
    variantDot.addEventListener("mouseover", function() {
        variantText.classList.add('active');
    }, false);

    variantDot.addEventListener("mouseout", function() {
        variantText.classList.remove('active');
    }, false);
});
